import Router from "vue-router";
import { RestUrl } from "@/commons/constants/RestUrl";
import UrlFormatter from "@/commons/utils/UrlFormatter";
import CommonService from "@/commons/services/CommonService";
import LoginUser from "@/store/LoginUser";
import SystemError from "@/commons/models/SystemError";
import { HitomeqErrorType } from "@/commons/models/SystemError";

/**
 * システムエラー送信
 */
export default class SendSystemError {
  /** 共通サービス */
  private commonService: CommonService;

  /**
   * ### コンストラクター
   *
   * - 共通サービスが渡されればそれを使用する
   * - 共通サービスが渡されなければ新しいインスタンスを作る
   *
   * @param commonService 共通サービス
   */
  constructor(commonService?: CommonService) {
    this.commonService = commonService ? commonService : new CommonService();
    return;
  }

  /**
   * システムエラーをAPIに送信してDBに保存する
   *
   * @param error エラークラス
   * @param axios axios
   * @param store vuex
   */
  public async post(error: any, userStore: LoginUser, router: Router, info?: any) {
    try {
      // どの施設でエラーが発生したか判断するためにfacilityIdを取得する
      // 何らかの原因で無効な値の場合は不正であることを示すために-1を入れる
      const facilityId: number = 1 < userStore.loginUser.facilityId ? userStore.loginUser.facilityId : -1;

      // ローカルストレージに持つアプリバージョンを取得する
      const version = localStorage.getItem("version");

      // Errorクラスをコピー
      const systemError: SystemError = JSON.parse(JSON.stringify(error));

      // Errorオブジェクトをstringify()した際に、messageとstackはchromeがjsonに変換してくれないので別途格納
      if (error.message) {
        systemError.errorMessage = error.message;
      }
      if (error.stack) {
        systemError.stackTrace = error.stack;
      }

      // 補足情報を格納
      if (router.currentRoute) {
        systemError.url = router.currentRoute.fullPath;
      }
      if (info) {
        systemError.info = info;
      }

      // エスケープ文字が入っていると、json化する際に問題が発生するので、エスケープ文字を削除しておく
      let errorString = JSON.stringify(systemError).replace(/\\/g, "");
      // json文字列を更にjson文字列化するので、"をエスケープするために\"に置換する
      errorString = errorString.replace(/"/g, '\\"');

      // システムエラーAPIへPOST
      const requestBody: any = {
        facilityId: facilityId,
        userId: userStore.loginUser.userId,
        error: errorString,
        browserAppVersion: version,
        apiUrl: error.apiUrl ? error.apiUrl : null,
        requestBody: error.requestBody ? error.requestBody : null
      };

      console.error(systemError);

      const formatParams: any = {
        facilityId: facilityId
      };
      const requestUrl: string = UrlFormatter.format(RestUrl.ErrorCollections, formatParams);
      await this.commonService.executePost(userStore, requestUrl, requestBody, this.constructor.name, HitomeqErrorType.REQUEST_RETRY, 0);
    } catch (error) {
      /**
       * システムエラー送信の場合、失敗した場合はどうすることもできない
       * 仕方がないのでここで握りつぶす
       */
      console.error(error);
    }
    return;
  }
}
